import { ReactNode, useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useLocation } from 'react-router-dom';

interface ProtectedRouteProps {
  children: ReactNode;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();
  const [shouldRedirect, setShouldRedirect] = useState(false);

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      setShouldRedirect(true);
      // Sauvegarder l'URL de destination pour redirection après login
      sessionStorage.setItem('redirect_after_login', location.pathname);
      window.REACT_APP_NAVIGATE('/login');
    } else if (!isLoading && isAuthenticated) {
      const needsOnboarding = localStorage.getItem('needs_onboarding');
      const currentPath = location.pathname;
      
      // Rediriger vers onboarding si nécessaire
      if (needsOnboarding === 'true' && currentPath !== '/onboarding') {
        window.REACT_APP_NAVIGATE('/onboarding');
      } 
      // Rediriger vers dashboard si onboarding déjà complété
      else if (needsOnboarding !== 'true' && currentPath === '/onboarding') {
        window.REACT_APP_NAVIGATE('/dashboard');
      }
    }
  }, [isAuthenticated, isLoading, location.pathname]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-emerald-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-slate-600 font-medium">Chargement...</p>
        </div>
      </div>
    );
  }

  if (shouldRedirect || !isAuthenticated) {
    return null;
  }

  return <>{children}</>;
};